import { Accept } from 'react-dropzone'

export const ACCEPT_DEFAULT: Accept = {
  'image/jpeg': ['.jpeg', '.jpg'],
  'image/png': ['.png'],
  'image/gif': ['.gif'],
  'application/pdf': ['.pdf'],
}

export type AcceptOption = Accept | 'all'

export const resolveAcceptedTypes = (accept?: AcceptOption): Accept | undefined =>
  accept === 'all' ? undefined : (accept ?? ACCEPT_DEFAULT)
